import {state as appStoreDialogState} from "@/store/modules/AppStoreDialog/appStoreDialog"
import {calcDateDiff, parseSysDate} from "@/plugins/formatting"
import {getters as accountGetters} from "@/store/modules/account"

export default function appStoreDialogGetters() {

    return {
        getSelectedCompany,
        getCurrentPlan,
        getCurrentFeature,
        getCurrentFeatureSettings,
        getSubscriptionDaysLeft,
        getTrialDaysLeft,
        getAccountIdFromAppData,
        getTabs,
        getSelectedTab,
        getSelectedTabName,
        getFooterActions,
        getSelectedTabOptions,
    }

    function getCurrentPlan() {
        const appData = appStoreDialogState.appData
        if (!appData) return

        let current_plan = appData.current_plan
        if (!current_plan) return

        return current_plan
        // const now = new Date()
        // const date_from = parseSysDate(current_plan.date_from)
        // const date_until = parseSysDate(current_plan.date_until)
        // if (date_from <= now && now < date_until) {
        //     return current_plan
        // }
    }

    function getCurrentFeature() {
        const appData = appStoreDialogState.appData
        return appData.account_feature || {}
    }

    function getCurrentFeatureSettings() {
        const appData = appStoreDialogState.appData
        return appData.account_feature_settings || {}
    }

    function getTrialDaysLeft() {
        let days = 0
        const current_plan = getCurrentPlan()
        if (current_plan && current_plan.is_trial === 1) {
            days = calcDateDiff.inDays(new Date(), parseSysDate(current_plan.date_until))
        }
        // console.info('getTrialDaysLeft', days)
        return days || 0
    }

    function getSubscriptionDaysLeft() {
        let days = 0
        const current_plan = getCurrentPlan()
        if (current_plan && current_plan.is_paid === 1) {
            days = calcDateDiff.inDays(new Date(), parseSysDate(current_plan.date_until))
        }
        // console.info('getSubscriptionDaysLeft', days)
        return days || 0
    }

    /*
    Other
     */
    function getSelectedCompany() {
        let company_id = getAccountIdFromAppData()
        let company = accountGetters.available_accounts.value.find(company => {
            return company && company.id === company_id
        })
        return company
    }

    function getAccountIdFromAppData() {
        const appData = appStoreDialogState.appData
        if (appData == null) return null
        return appData.account_id
    }

    function getTabs() {
        return appStoreDialogState.tabs
    }

    function getSelectedTab() {
        return appStoreDialogState.tabs.findIndex(x => x.name === appStoreDialogState.currentTab)
    }

    function getSelectedTabOptions() {
        return appStoreDialogState.currentTabOptions
    }

    function getFooterActions() {
        return appStoreDialogState.footerActions
    }

    function getSelectedTabName() {
        return appStoreDialogState.currentTab
    }
}